import { createMuiTheme } from '@material-ui/core'

const palette = {
  type: 'dark',
  background: {
    default: '#303030',
  },
  primary: {
    light: '#BEA470',
    main: '#B6995E',
    dark: '#A18245',
    contrastText: '#FFF',
  },
  secondary: {
    light: '#ff8a68',
    main: '#ed583c',
    dark: '#b42212',
    contrastText: '#FFF',
  },
  grey: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#EEEEEE',
    300: '#E0E0E0',
    400: '#BDBDBD',
    500: '#9E9E9E',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#E7E7E7',
  },
}

export default createMuiTheme({
  palette,
  status: {
    pilot: '#03A9F4',
    published: '#42FF4F',
    finished: '#FF5722',
    downVote: '#d92300',
    upVote: '#00b649',
    copied: '#7CE073',
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
      'Karla',
    ].join(','),
  },
  overrides: {
    MuiStepper: {
      root: {
        backgroundColor: 'transparent',
      },
    },
    MUIRichTextEditor: {
      root: {
        backgroundColor: 'transparent',
      },
      container: {
        display: 'flex',
        flexDirection: 'column-reverse',
      },
      editor: {
        backgroundColor: 'transparent',
        padding: '20px',
        height: '200px',
        maxHeight: '200px',
        overflow: 'auto',
        border: `1px solid ${palette.grey[700]}`,
        borderRadius: '4px',
        '&:hover': {
          borderColor: '#fff',
        },
        '&:focus': {
          // NOT WORKING
          borderColor: palette.primary.main,
        },
      },
      toolbar: {
        marginTop: '8px',
        backgroundColor: 'transparent',
      },
      placeHolder: {
        paddingLeft: 20,
        width: '100%',
        height: '150px',
        position: 'absolute',
        top: '20px',
      },
      anchorLink: {
        color: palette.primary.main,
        textDecoration: 'underline',
        '&:visited': {
          color: palette.primary.dark,
        },
      },
    },
  },
})
